// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__sIzpU","spin":"style_spin__4f3F7"};